import { render, staticRenderFns } from "./PageMetaEditor.vue?vue&type=template&id=8e04ed4a&scoped=true&"
import script from "./PageMetaEditor.vue?vue&type=script&lang=js&"
export * from "./PageMetaEditor.vue?vue&type=script&lang=js&"
import style0 from "./PageMetaEditor.vue?vue&type=style&index=0&id=8e04ed4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e04ed4a",
  null
  
)

export default component.exports